module.exports = __webpack_public_path__ + "static/media/send.85048ab4.svg";